<template>
    <v-card color="primary" class="mb-5">
        <v-card-title>
            <v-container fluid>
                <v-row class="align-center">


                    <v-col cols="2" class="d-flex align-center">
                        <v-btn icon="mdi-arrow-left" variant="text" @click="$router.go(-1)"></v-btn>
                    </v-col>


                    <v-col cols="8" class="text-center text-wrap">
                        <h2 class="text-white text-h6">{{ type + ' - ' + title }}</h2>
                    </v-col>

                    <v-col cols="2" class="d-flex justify-end">
                        <v-btn v-if="can_edit" icon="mdi-pencil" variant="text" @click="emit('editModal')"></v-btn>
                        <v-btn v-if="can_delete" icon="mdi-delete" variant="text" @click="emit('deleteModal')"></v-btn>
                    </v-col>

                </v-row>
            </v-container>
        </v-card-title>
    </v-card>
</template>

<script setup>
defineProps({
    title: String,
    type: String,
    can_edit: Boolean,
    can_delete: Boolean,
});

const emit = defineEmits(["editModal", "deleteModal"]);
</script>
